/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BuilderNavigationService, CommonActions, CommonFlowState, ListActionPipelines } from '@gh/builder-shared';
import { AppRouter, getRouteInitData } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { RouteDataService, SlicedDataSource } from '@gh/core-data';
import { cursorTracker, newGridPaginationCursor } from '@gh/core-ui-grid';
import { MasterZoneListBusinessService } from '../../resources/master-zone-list-business.service';
import { MasterZoneListItem } from '../../resources/master-zone-list-item.model';
import { MasterZonesGridDefinition } from './master-zone-list-grid-definition.service';

@Component({
  selector: 'gh-master-zone-list',
  template: require('./master-zone-list.component.html'),
  styles: [require('./master-zone-list.component.scss')],
  viewProviders: [
    MasterZonesGridDefinition,
  ],
})
export class MasterZoneListComponent implements OnInit {
  dataSource: SlicedDataSource<MasterZoneListItem>;
  cursor = newGridPaginationCursor();

  constructor(private router: AppRouter,
              private route: ActivatedRoute,
              private routeData: RouteDataService,
              private navigationService: BuilderNavigationService,
              private businessService: MasterZoneListBusinessService,
              private pipelines: ListActionPipelines,
              private commonActions: CommonActions,
              public gridDefinition: MasterZonesGridDefinition) {
  }

  /**
   * Init component
   */
  ngOnInit(): void {
    const { gridLayout } = getRouteInitData(this.route);

    this.gridDefinition.bind(gridLayout);

    const tracker = this.routeData.tracker().withEffects(cursorTracker(this.cursor));
    tracker.listen(this.route);
    tracker.filterChanges.subscribe(() => this.loadData());
  }

  loadData(): void {
    this.dataSource = this.businessService.findAllAsDataSource();
  }

  onCreate(): void {
    this.router.navigateToChild(['/master-zones/new']);
  }

  onEdit(masterZone: MasterZoneListItem): void {
    this.router.navigateToChild(['/master-zones', masterZone.id]);
  }

  onDeactivate(masterZone: MasterZoneListItem): void {
    const flow = this.pipelines.toggleItem({
      question: 'msg_master_zone_deactivation',
      successMessage: { id: 'msg_master_zone_deactivated_successfully', params: { name: masterZone.name } },
      validate: this.commonActions.validate((state: CommonFlowState<MasterZoneListItem>) =>
        this.businessService.validate(state.value.id)),
      execute: this.commonActions.execute((state: CommonFlowState<MasterZoneListItem>) =>
        this.businessService.deactivate(state.value)),
      finish: () => this.loadData(),
    });

    flow.run({
      value: masterZone,
    });
  }

  goToAel(entityId?: ID, entityType?: string, label?: string): void {
    this.navigationService.goToAel({
      entityId: entityId ? entityId : undefined,
      entityType: entityType ? entityType : 'MASTER_ZONE',
      label: label ? label : 'lbl_menu_master_zones',
    });
  }
}
